import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas.sort((a, b) => b.order - a.order) },
    filtered: (state, datas) => { state.filtered = datas.map(item => item.id) }
  },
  actions: {
    init (state) { socket.get('SportSportEventunit', 'Sport/EventUnit/init') },
    set (state, data) {
      state.state.filtered = []

      if (data.sportId > 0) {
        const parameters = { join: [], joinr: [] }

        if (data.eventId > 0) {
          parameters.eventId = data.eventId
        } else if (data.disciplineId > 0 || data.sportId > 0) {
          parameters.join.push('SportSportEventunit.eventId')
          if (data.disciplineId > 0) {
            parameters['SportSportEvent.disciplineId'] = data.disciplineId
          }
          if (data.sportId > 0) {
            parameters['SportSportDiscipline.sportId'] = data.sportId
            parameters.join.push('SportSportEvent.disciplineId')
          }
        }
        if (data.classificationId > 0) {
          parameters['SportSportEventunitclassification.classificationId'] = data.classificationId
          parameters.joinr.push('SportSportEventunitclassification.eventUnitId')
        }
        if (data.genderId > 0) {
          parameters.genderId = data.genderId
        }
        if (data.categoryId > 0) {
          parameters.categoryId = data.categoryId
        }

        if (data.seasonId > 0 || data.competitionsId.length > 0) {
          parameters.joinr.push('SportSportRound.eventUnitId')
          parameters.join.push('SportSportRound.competitionSeasonId')

          if (data.seasonId > 0) {
            parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
          }

          if (data.competitionsId.length === 1) {
            parameters['SportSportCompetitionseason.competitionId'] = data.competitionsId[0]
          } else if (data.competitionsId.length > 1) {
            parameters['SportSportCompetitionseason.competitionId'] = {
              column: 'SportSportCompetitionseason.competitionId',
              operator: 'in',
              value: data.competitionsId
            }
          }
        }

        socket.get('SportSportEventunit', 'Sport/EventUnit/filtered', parameters)
      }
    }
  },
  getters: {
    list: (state) => state.list,
    filtered: (state) => state.filtered,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
